
export default class RatingInputService {

	constructor() {
		this.init();
	}

	init() {
		console.log('RatingInputService initialized');
		this.setupEventListeners();
		this.checkInitialRating();
	}

	setupEventListeners() {
		const stars = document.querySelectorAll('.ti-quick-rating .star-check .star');
		stars.forEach(star => {
			star.addEventListener('mouseenter', this.setRating.bind(this));
			star.addEventListener('mouseout', this.setRating.bind(this));
		});
	}

	checkInitialRating() {
		const checkedRadio = document.querySelector('.write-a-review input[name="rating"]:checked');
		if (checkedRadio) {
			const star = checkedRadio.closest('.star-check').querySelector('.star');
			this.triggerMouseOut(star);
			document.querySelector('.toggle-rating').style.display = 'block';
		}
	}

	setRating(event) {
		event.preventDefault();
		const star = event.currentTarget;
		const parent = star.closest('.ti-quick-rating');
		let rating = star.nextElementSibling.value;

		if (event.type === 'mouseout' || event.type === 'mouseleave') {
			const checkedRadio = parent.querySelector('input[type="radio"]:checked');
			if (checkedRadio) {
				rating = checkedRadio.value;
			} else {
				rating = undefined;
			}
		}

		parent.className = parent.className.replace(/\s?rating-\d\s?/, '');
		if (rating !== undefined) {
			parent.classList.add('rating-' + rating);
		}
	}

	triggerMouseOut(element) {
		const event = new Event('mouseout', {
			bubbles: true,
			cancelable: true
		});
		element.dispatchEvent(event);
	}

	setupInputListener() {
		const stars = document.querySelectorAll('.ti-quick-rating .star-check .star');
		stars.forEach(star => {
			star.addEventListener('click', (event) => {
				document.querySelectorAll('.ti-quick-rating input[name=rating]').forEach(input => {
					input.checked = false;
				});

				const radio = star.nextElementSibling;
				if (radio) {
					radio.checked = true;
					const quickRating = document.querySelector('.ti-quick-rating');
					if (quickRating) {
						quickRating.className = 'ti-quick-rating rating-' + radio.value;

						// the rating is sent on with the star, e.g. the rating step of an SMS review link
						if (quickRating.dataset.ratingUrl) {
							window.location.href = quickRating.dataset.ratingUrl + '?star=' + radio.value;
						}
					}
				}

				const toggleRating = document.querySelector('.toggle-rating');
				if (toggleRating) {
					toggleRating.style.display = 'block';
				}

				event.preventDefault();
			});
		});
	}
}